import React from 'react';
import { TEST_IDS } from 'shared';
import { InputField } from 'components/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { FinanceProgramFormValues } from '../../../../../../types';
import { FinanceFieldSelector } from '../../../../../components/finance/FinanceFieldSelector';
import { deskingSelectors } from 'modules/desking/model';
import { useSelector } from 'react-redux';

export const FinanceExistingProgramFields = () => {
  const isFinanceDetailsEditable = useSelector(deskingSelectors.selectFinanceDetailsEditableStatus);

  const { control } = useFormContext<FinanceProgramFormValues>();
  const program = useWatch({ control, name: 'financeQuote.program' });

  const isProgramSelected = Boolean(program);

  return (
    <>
      <FinanceFieldSelector />

      {isProgramSelected && (
        <InputField
          control={control}
          label="Finance Program Name"
          name="financeQuote.programName"
          dataTestId={TEST_IDS.desking.finance.programName}
          inputProps={{ disabled: !isFinanceDetailsEditable }}
        />
      )}
    </>
  );
};
